import { config } from '@services/config';
import { BrokerageUserSearchRequestQuery } from '@lio/api-types';
import { BrokerageUserSearchResponseWithPagination } from '@services/brokerage/brokerage.types';
import { getBrokerageUsersQuery } from '@services/brokerage/user/userQuery';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { brokerageUserKeys } from './user.keys';

interface TSearchBrokerageUsersProps extends BrokerageUserSearchRequestQuery {
  enabled: boolean;
  brokerageId: string;
}

export const useSearchBrokerageUsers = ({
  enabled = false,
  brokerageId,
  pageOffset,
  pageLimit,
  sort,
  role,
  searchText,
}: TSearchBrokerageUsersProps) => {
  const client = useClient();
  const query = getBrokerageUsersQuery({ pageLimit, pageOffset, role, sort, searchText });
  const result = useQuery({
    queryKey: brokerageUserKeys.search(brokerageId ?? '', query),
    queryFn: async () => {
      const response = await client
        .get(`brokerage/${brokerageId}/user?${query}`)
        .json<BrokerageUserSearchResponseWithPagination>();
      return response;
    },
    placeholderData: keepPreviousData,
    enabled: Boolean(brokerageId) || enabled,
    refetchOnWindowFocus: false,
    retry: false,
    ...config,
  });
  return { ...result, brokerageUsers: result.data };
};
